import { AlertConfig, AlertTypes, ButtonType, HeadingType } from "@rappider/rappider-components/utils";

export const errorAlertConfig: AlertConfig = {
  type: AlertTypes.Error,
  title: {
    content: 'An error occurred',
    type: HeadingType.H5
  },
  description: {
    text: ''
  },
  showIcon: true,
  closeable: false
};

export const connectIcon = {
  type: 'FONT_AWESOME',
  name: 'fa-solid fa-lock-keyhole',
  size: 'var(--height-x)'
}

export const connectAlertConfig: AlertConfig = {
  type: AlertTypes.Info,
  title: {
    content: '',
  },
  description: {
    text: ''
  },
  showIcon: true,
  closeable: false
};
